var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticClass: "table",
          attrs: {
            data: _vm.skuTransportList,
            size: "mini",
            "highlight-current-row": "",
            "header-cell-style": { fontWeight: "bold" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "skuName", label: "商品", "min-width": "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _c(
                    "div",
                    {},
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: scope.row.orderItemIdList,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "orderItemIdList", $$v)
                            },
                            expression: "scope.row.orderItemIdList",
                          },
                        },
                        _vm._l(scope.row.skuLists, function (skuItem) {
                          return _c(
                            "el-checkbox",
                            { key: skuItem.id, attrs: { label: skuItem.id } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "sku-name-text",
                                  attrs: {
                                    title:
                                      skuItem.skuName +
                                      " x" +
                                      skuItem.skuQuantity,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      skuItem.skuName +
                                        " x" +
                                        skuItem.skuQuantity
                                    )
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "物流", "min-width": "380" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _c(
                    "div",
                    {},
                    [
                      _c("SendCompany", {
                        model: {
                          value: scope.row.sendLists,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "sendLists", $$v)
                          },
                          expression: "scope.row.sendLists",
                        },
                      }),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          attrs: { type: "primary", size: "small" },
          on: { click: _vm.addSkuCompany },
        },
        [_vm._v("添加发货物流")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }